/**
 * Item service API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CategoryPropertyShared } from './categoryPropertyShared';
import { ShortPromocodeShared } from './shortPromocodeShared';


export interface PromotionFullInfoShared { 
    id?: number;
    title?: string;
    description?: string;
    categories?: Array<CategoryPropertyShared>;
    promocodes?: Array<ShortPromocodeShared>;
    discountType?: PromotionFullInfoShared.DiscountTypeEnum;
    badgeId?: number;
    tagId?: number;
    promotionStatus?: PromotionFullInfoShared.PromotionStatusEnum;
    startedAt?: Date;
    finishedAt?: Date;
    preparationStartDate?: Date;
    preparationEndDate?: Date;
}
export namespace PromotionFullInfoShared {
    export type DiscountTypeEnum = 'PERCENT' | 'ABS' | 'PROMOCODE';
    export const DiscountTypeEnum = {
        PERCENT: 'PERCENT' as DiscountTypeEnum,
        ABS: 'ABS' as DiscountTypeEnum,
        PROMOCODE: 'PROMOCODE' as DiscountTypeEnum
    };
    export type PromotionStatusEnum = 'INACTIVE' | 'PREPARATION' | 'PUBLISHED' | 'FINISHED' | 'DRAFT' | 'FREEZE';
    export const PromotionStatusEnum = {
        INACTIVE: 'INACTIVE' as PromotionStatusEnum,
        PREPARATION: 'PREPARATION' as PromotionStatusEnum,
        PUBLISHED: 'PUBLISHED' as PromotionStatusEnum,
        FINISHED: 'FINISHED' as PromotionStatusEnum,
        DRAFT: 'DRAFT' as PromotionStatusEnum,
        FREEZE: 'FREEZE' as PromotionStatusEnum
    };
}


